/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Image, Layers, VisibilityOffOutlined, VisibilityOutlined, Fullscreen, FullscreenExit } from '@mui/icons-material';
import { Box, Button, Checkbox, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { VAccordion } from '../../shared';
import { MarkerPoint } from '../Map';
import { DamsServices } from '../../../services/api/dams/DamServices';
import { exportComponentAsJPEG } from 'react-component-export-image';
import { useParams } from 'react-router-dom';

import { Filesystem, Directory } from '@capacitor/filesystem';
import { getUniqueFileName } from '../../../services/helpers/helpers';
import { AppSnackbarAlert } from '../../shared/AppSnackbarAlert';

import { Capacitor } from '@capacitor/core';

interface ButtonsDamInformationProps {
    showLabel?: boolean;
    handleLabelChange: (showLabel: boolean) => void;
    markerPoints: MarkerPoint[];
    handleShowMarkerChange: (index: string) => void;
    handleDisableMarkersOfType: (type: string, enable: boolean) => void;
    uuid?: string;
    mapRef?: any;
    isFullScreen?: boolean;
    toggleFullScreen?: () => void;
}

export const ButtonsDamInformation: React.FC<ButtonsDamInformationProps> = ({ handleLabelChange, markerPoints, handleShowMarkerChange, handleDisableMarkersOfType, uuid, mapRef, isFullScreen, toggleFullScreen }) => {
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const url = useParams();

    const [localShowLabel, setLocalShowLabel] = useState(true);

    const [alertMessage, setAlertMessage] = useState<string>('');
    const [alertSeverity, setAlertSeverity] = useState<'error' | 'warning' | 'info' | 'success'>('info');
    const [showAlertState, setShowAlertState] = useState<boolean>(false);

    const displayAlert = (message: string, severity: typeof alertSeverity) => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setShowAlertState(true);
    };

    const handleCloseAlert = () => {
        setShowAlertState(false);
    };

    useEffect(() => {
        if (uuid === undefined) {
            uuid = url.dam;
        }
    }, [uuid, url.dam]);


    function checkAllActive(type: string) {
        return markerPoints.some(marker => marker.type === type && marker.showMarker);
    }

    function checkAllInactive(type: string): boolean {
        return markerPoints.filter(marker => marker.type === type).every(marker => !marker.showMarker);
    }

    function localHandleLabelChange() {
        const newShowLabel = !localShowLabel;
        setLocalShowLabel(newShowLabel);
        handleLabelChange(newShowLabel);
    }

    function handleChangeButtom(type: string) {
        let newActive = false;
        if (type === 'piezometro') {
            newActive = checkAllInactive(type);
        } else if (type === 'vazao') {
            newActive = checkAllInactive(type);
        } else if (type === 'regua') {
            newActive = checkAllInactive(type);
        } else if (type === 're') {
            newActive = checkAllInactive(type);
        } else if (type === 'base') {
            newActive = checkAllInactive(type);
        } else if (type === 'inclinometro') {
            newActive = checkAllInactive(type);
        } else if (type === 'pluviometro') {
            newActive = checkAllInactive(type);
        } else if (type === 'marco') {
            newActive = checkAllInactive(type);
        } else if (type === 'indicador') {
            newActive = checkAllInactive(type);
        }
        handleDisableMarkersOfType(type, newActive);
    }

    async function handleExportImage() {
        if (!mapRef || !mapRef.current) {
            displayAlert('Referência do mapa não disponível para exportação.', 'error');
            return;
        }

        const fileName = 'Mapa_Exportado.jpeg';

        try {

            if (Capacitor.isNativePlatform()) {

                displayAlert('Exportação de imagem não suportada diretamente em dispositivos móveis no momento. Por favor, use a versão web.', 'info');
                return;

            } else {
                exportComponentAsJPEG(mapRef, { fileName: fileName });
                displayAlert(`Download de "${fileName}" iniciado!`, 'success');
            }
        } catch (error: any) {
            displayAlert(`Erro ao exportar imagem: ${error.message}.`, 'error');
        }
    }

    async function downloadKml() {
        const getShowMarkerUuids = () => {
            if (markerPoints) {
                const visibleMarkers = markerPoints.filter(marker => marker.showMarker === true);
                if (visibleMarkers.length > 0) {
                    const uuids = visibleMarkers.map(marker => marker.uuid);
                    return { uuid: uuids };
                }
            }
            return undefined;
        };

        if (!uuid) {
            displayAlert('Erro: UUID da barragem não disponível para exportação KML.', 'error');
            return;
        }

        try {
            const dataToSend = getShowMarkerUuids();

            if (Capacitor.isNativePlatform()) {
                const response = await DamsServices.getKmlBlob(uuid, dataToSend);

                if (!(response.data instanceof Blob)) {
                    throw new Error('Resposta da API para KML não é um Blob válido.');
                }

                const kmlBlob = response.data;

                const contentDisposition = response.headers['content-disposition'];
                let fileName = `mapa_${uuid}.kml`;
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (fileNameMatch && fileNameMatch.length >= 2) {
                        fileName = fileNameMatch[1];
                    }
                }

                const permissionStatus: any = await Filesystem.checkPermissions();
                const hasPermission = permissionStatus.publicStorage === 'granted' ||
                    permissionStatus.mediaImages === 'granted' ||
                    permissionStatus.mediaVideo === 'granted' ||
                    permissionStatus.mediaAudio === 'granted' ||
                    permissionStatus.write === 'granted';

                if (!hasPermission) {
                    const requestResult: any = await Filesystem.requestPermissions();
                    const newHasPermission = requestResult.publicStorage === 'granted' ||
                        requestResult.mediaImages === 'granted' ||
                        requestResult.mediaVideo === 'granted' ||
                        requestResult.mediaAudio === 'granted' ||
                        requestResult.write === 'granted';

                    if (!newHasPermission) {
                        displayAlert('Permissão de armazenamento necessária para baixar o KML!', 'error');
                        return;
                    }
                }

                const reader = new FileReader();
                reader.readAsDataURL(kmlBlob);
                reader.onloadend = async () => {
                    const base64Content = (reader.result as string).split(',')[1];

                    const finalFileName = await getUniqueFileName(fileName, Directory.Documents);

                    await Filesystem.writeFile({
                        path: finalFileName,
                        data: base64Content,
                        directory: Directory.Documents,
                        recursive: true
                    });
                    displayAlert(`Arquivo KML "${finalFileName}" salvo em Documentos!`, 'success');
                };
                reader.onerror = () => {
                    displayAlert('Erro ao ler o arquivo KML para download.', 'error');
                };
            } else {
                await DamsServices.getKml(uuid, dataToSend);

                displayAlert('Download de KML iniciado!', 'success');
            }
        } catch (error: any) {
            if (error.message && error.message.includes('Permission denied')) {
                displayAlert('Permissão de armazenamento negada. Habilite nas configurações do app.', 'error');
            } else {
                displayAlert(`Erro ao baixar KML: ${error.message}.`, 'error');
            }
        }
    }

    const hasPiezometroMarkers = markerPoints.some(marker => marker.type === 'piezometro');
    const hasIndicadorMarkers = markerPoints.some(marker => marker.type === 'indicador');
    const hasVazaoMarkers = markerPoints.some(marker => marker.type === 'vazao');
    const hasReguaMarkers = markerPoints.some(marker => marker.type === 'regua');
    const hasReMarkers = markerPoints.some(marker => marker.type === 're');
    const hasBaseMarkers = markerPoints.some(marker => marker.type === 'base');
    const hasInclinometroMarkers = markerPoints.some(marker => marker.type === 'inclinometro');
    const hasPluviometricoMarkers = markerPoints.some(marker => marker.type === 'pluviometrico');
    const hasTopograficoMarkers = markerPoints.some(marker => marker.type === 'marco');

    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            padding={1}
            gap={1}
            alignContent={'center'}
            justifyContent={'center'}
            width={smDown ? '95%' : '100%'}
            overflow={'hidden'}
        >
            {Capacitor.isNativePlatform() && toggleFullScreen && (
                <Button
                    variant='contained'
                    disableElevation
                    startIcon={isFullScreen ? <FullscreenExit /> : <Fullscreen />}
                    fullWidth
                    onClick={toggleFullScreen}
                    sx={{ borderRadius: '25px' }}
                >
                    <Typography variant='button' whiteSpace={'normal'}>
                        {isFullScreen ? 'Sair da Tela Cheia' : 'Entrar em Tela Cheia'}
                    </Typography>
                </Button>
            )}

            <Button
                variant='outlined'
                disableElevation
                startIcon={<Image />}
                fullWidth
                onClick={handleExportImage}
                sx={{ borderRadius: '25px' }}
            >
                <Typography
                    variant='button'
                    whiteSpace={'normal'}
                >
                    Exportar IMG {Capacitor.isNativePlatform() && isFullScreen ? 'da Tela' : ''}
                </Typography>
            </Button>
            <Button
                variant='outlined'
                disableElevation
                color={'primary'}
                startIcon={<Layers />}
                onClick={downloadKml}
                sx={{ borderRadius: '25px' }}
            >
                <Typography
                    variant='button'
                    whiteSpace={'normal'}
                >
                    Exportar KML
                </Typography>
            </Button>
            <Button
                variant='contained'
                disableElevation
                startIcon={localShowLabel ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                onClick={() => localHandleLabelChange()}
                sx={{ borderRadius: '25px' }}
            >
                <Typography
                    variant='button'
                >
                    {localShowLabel ? 'Remover nome' : 'Mostrar nome'}
                </Typography>
            </Button>
            <Divider flexItem />
            <Box
                display={'flex'}
                flexDirection={'column'}
                sx={{
                    overflowY: 'auto',
                    maxHeight: '40vh'
                }}
            >
                {hasPiezometroMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Piezômetro'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('piezometro')} fullWidth variant='outlined'>
                                        {checkAllActive('piezometro') ? 'Desativar' : 'Ativar'} todos os Piezômetros
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 'piezometro')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>
                }
                {hasIndicadorMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Indicador de nível'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('indicador')} fullWidth variant='outlined'>
                                        {checkAllActive('indicador') ? 'Desativar' : 'Ativar'} todos os indicadores
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 'indicador')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>
                }
                {hasVazaoMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Medidor de vazão'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('vazao')} fullWidth variant='outlined'>
                                        {checkAllActive('vazao') ? 'Desativar' : 'Ativar'} todos os medidores de vazões
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 'vazao')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>}
                {hasReguaMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Régua de reservatorio'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('regua')} fullWidth variant='outlined'>
                                        {checkAllActive('regua') ? 'Desativar' : 'Ativar'} todas as réguas
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 'regua')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>}
                {hasReMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Ré topográfico'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('re')} fullWidth variant='outlined'>
                                        {checkAllActive('re') ? 'Desativar' : 'Ativar'} todos os ré topográfico
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 're')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>}
                {hasBaseMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Base da estação total'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('base')} fullWidth variant='outlined'>
                                        {checkAllActive('base') ? 'Desativar' : 'Ativar'} todas as bases
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 'base')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>}
                {hasInclinometroMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Inclinômetro'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('inclinometro')} fullWidth variant='outlined'>
                                        {checkAllActive('inclinometro') ? 'Desativar' : 'Ativar'} todas os Inclinômetros
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 'inclinometro')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>
                }
                {hasPluviometricoMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Pluviômetrico'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('pluviometrico')} fullWidth variant='outlined'>
                                        {checkAllActive('pluviometrico') ? 'Desativar' : 'Ativar'} todos os Pluviômetricos
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 'pluviometrico')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>}
                {hasTopograficoMarkers &&
                    <Box padding={1}>
                        <VAccordion
                            title='Marco topográfico'
                            content={
                                <Box>
                                    <Button onClick={() => handleChangeButtom('marco')} fullWidth variant='outlined'>
                                        {checkAllActive('marco') ? 'Desativar' : 'Ativar'} todos os marcos topográficos
                                    </Button>
                                    {markerPoints
                                        .filter(marker => marker.type === 'marco')
                                        .map((marker, index) => (
                                            <ListItem key={index}>
                                                <ListItemButton role={undefined} dense onClick={() => handleShowMarkerChange(marker.uuid)}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={marker.showMarker} onChange={() => handleShowMarkerChange(marker.uuid)} />
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {marker.title}
                                                    </ListItemText>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                </Box>
                            }
                        />
                    </Box>}
            </Box>
            {showAlertState && (
                <AppSnackbarAlert
                    message={alertMessage}
                    severity={alertSeverity}
                    open={showAlertState}
                    onClose={handleCloseAlert}
                />
            )}
        </Box>
    );
};